import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const ServiceCard = ({ service, dark = true, detailed = false }) => {
  const { t } = useLanguage();
  const Icon = service.icon;
  return (
    <div
      id={service.id}
      data-testid={`service-card-${service.id}`}
      className={`group scroll-mt-32 rounded-2xl border p-8 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 ${
        dark
          ? "border-white/10 bg-white/[0.04] hover:border-gold/50"
          : "border-charcoal/10 bg-white hover:border-gold-dark/40 hover:shadow-[0_20px_50px_rgba(18,18,18,0.08)]"
      }`}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 transition-colors group-hover:bg-gold/25">
        <Icon className="h-6 w-6 text-gold" aria-hidden="true" />
      </div>
      <h3 className={`mt-6 font-display text-2xl ${dark ? "text-offwhite" : "text-charcoal"}`}>{service.name}</h3>
      <p className={`mt-3 text-sm leading-relaxed ${dark ? "text-white/60" : "text-charcoal/65"}`}>{service.desc}</p>
      {detailed && (
        <div className="mt-5 flex flex-wrap gap-2">
          {service.items.map((item) => (
            <span key={item} className={`rounded-full px-3 py-1 text-xs font-semibold ${dark ? "bg-white/10 text-white/70" : "bg-charcoal/5 text-charcoal/70"}`}>
              {item}
            </span>
          ))}
        </div>
      )}
      {!detailed && (
        <Link
          to={`/services#${service.id}`}
          data-testid={`service-learn-more-${service.id}`}
          className={`mt-6 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.15em] transition-colors ${
            dark ? "text-gold hover:text-gold-soft" : "text-gold-dark hover:text-gold"
          }`}
        >
          {t("cta.learnMore")}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
};
